export default class DropdownOption<T> {
  public value?: T = undefined;
  public label: string = "";
}
